import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {apphistory, AppState} from '../../../store'
import useTextContents from '../../../hooks/useTextContents'
import {AppLinks} from '../../../environment/app-links'
import videoVerificationService from '../../../service/VideoVerificationService'
import {createVideoVerificationIdentificationLink} from '../../../common/helpers/videoVerificationHelper'
import {SET_GENERATE_SESSION_PARAMS} from '../../../store/actions/video-verification-actions'
import Button from '../../../components/button/Button'
import {STORAGEKEYS} from '../../../common/keys'
import {SessionStorage} from '../../../common/cookie-storage'
import analyticsService from '../../../service/analytics.service'
import {sleep} from '../../../common/helpers/helpers'
import {AppButtonTypes} from '../../../components/button/ButtonProps'

import {ReactComponent as IdentLogo} from '../../../icons/svg/ident_logo.svg'
import './VideoVerificationStartPageStyles.scss'
import PageScreen from "../../../components/organisms/Page/PageScreen";
import {AppList} from "../../../components/atoms/AppList/AppList";
import {List_TYPE} from "../../../components/atoms/AppList/AppListProps";
import {AppListItem} from "../../../components/atoms/AppListItem/AppListItem";
import Paragraph from "../../../components/atoms/Paragraph/Paragraph";
import PageHeader from "../../../components/atoms/PageHeader/PageHeader";
import {HEADER_LEVEL} from "../../../components/atoms/PageHeader/PageHeaderProps";
import AppButton from "../../../components/atoms/AppButton/AppButton";
import LoanOfferSummaryPanel from '../../../components/organisms/LoanOfferSummaryPanel/LoanOfferSummaryPanel'


const VideoVerificationStartPage = () => {
    const dispatch = useDispatch()
    const textContent = useTextContents()
    const sessionStorage = new SessionStorage()

    const ANALYTICS_EVENT_TYPES_NAMES = useSelector((state: AppState) => state.lenConfigState.analyticsEventTypesNames)


    const handleOnSubmitButtonClick = async () => {
        const alphaId = sessionStorage.get(STORAGEKEYS.SET_ALPHA_ID)

        try {
            apphistory.push(AppLinks.waiting)
            await sleep(1500)
            const generateVideoVerificationSessionResponse = await videoVerificationService.generateSession()

            dispatch({
                type: SET_GENERATE_SESSION_PARAMS,
                payload: generateVideoVerificationSessionResponse
            })

            const videVerificationLink = createVideoVerificationIdentificationLink({...generateVideoVerificationSessionResponse})
            await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.ManualVerificationIdenttUserEntrance)

            window.location.href = videVerificationLink.href
        } catch (e: any) {
            const ERROR_ANALYTICS_DATA = {
                id: analyticsService.DISPLAY_ERROR_PAGE_IDS.VIDEO_VERIFICATION_GENERATE_SESSION_FAIL,
                reason: `Nie udało się poprawnie rozpocząć procesu wideo weryfikacji - błąd podczas generowania sesji wideo weryfikacji (/videoVerification/manual/generateSession).`,
                details: {
                    description: e.message,
                    errorDataFromBackend: {...e},
                    additionalData: {
                        description: 'Parametry, które zostały wysłane do backendu w celu wygenerowania sejsji wideo weryfikacji.',
                        alphaId
                    }
                },
            }
            
            await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.FrontendErrorPageDisplayed, JSON.stringify(ERROR_ANALYTICS_DATA, undefined, 3))
            apphistory.push(AppLinks.clientChoiceManualVerification)
        }
    }

    const handleOnPrevButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        apphistory.push(AppLinks.clientChoiceManualVerification)
    }

    return (
        <PageScreen
            title={{ title: textContent('videoVerificationStartPage.manual_verification.first_section.heading'), line: true }}
            panel={<LoanOfferSummaryPanel readOnly={true} loanVariant='selectedOffer' />}
            showBackButton={true} onClickBack={handleOnPrevButtonClick}
        >
            <div className={"page-gap"}>
                <Paragraph align={"center"}>
                    {textContent('videoVerificationStartPage.manual_verification.first_section.subheading')}
                </Paragraph>

                <AppList listType={List_TYPE.UNORDERED}>
                    <AppListItem
                        html={textContent('videoVerificationStartPage.manual_verification.first_section.list_option_1')}/>
                    <AppListItem
                        html={textContent('videoVerificationStartPage.manual_verification.first_section.list_option_2')}/>
                    <AppListItem
                        html={textContent('videoVerificationStartPage.manual_verification.first_section.list_option_3')}/>
                </AppList>
                <div>
                    <PageHeader
                            title={textContent('videoVerificationStartPage.manual_verification.second_section.heading')}
                            level={HEADER_LEVEL.H2}/>

                    <AppList>
                        <AppListItem>{textContent('videoVerificationStartPage.manual_verification.second_section.list_option_1')}</AppListItem>
                        <AppListItem>{textContent('videoVerificationStartPage.manual_verification.second_section.list_option_2')}</AppListItem>
                        <AppListItem>{textContent('videoVerificationStartPage.manual_verification.second_section.list_option_3')}</AppListItem>
                    </AppList>
                </div>
                <div className={"center"}>
                    <AppButton onClick={handleOnSubmitButtonClick}>
                        {textContent('buttons.videoVerificationStartProcess')}
                    </AppButton>
                </div>
                <div className={"center"}>
                    <IdentLogo/>
                </div>
            </div>
        </PageScreen>


    )
}


export default VideoVerificationStartPage